import { format } from 'date-fns'
import { CACHE_FOR } from '@/config/constants'
// TODO: There is a chance that this paths will be out of sync with current locale. Figure out how to fix it.
import { factoryDashboardPath } from '@/lib/routes'
import { startOfWorkDay } from '@/lib/shiftTime'

export const pageConfig: PageConfig = {
  cacheFor: args => {
    if (typeof window === 'undefined' || !args?.url) {
      return CACHE_FOR.LONG
    }

    const url = new URL(args.url, window.location.origin)
    const now = format(new Date(), 'yyyy-MM-dd')

    if (
      (!url.searchParams.has('from') && !url.searchParams.has('to')) ||
      (url.searchParams.get('from') === now && url.searchParams.get('to') === now)
    ) {
      return CACHE_FOR.DEFAULT
    }

    return CACHE_FOR.LONG
  },
  overrideLinkHref: href => {
    const url = new URL(href, window.location.origin)
    if (url.searchParams.has('from') && url.searchParams.has('to')) {
      return href
    }

    const now = format(startOfWorkDay(new Date()), 'yyyy-MM-dd')
    return factoryDashboardPath({ from: now, to: now, shift: 'A' })
  },
}
